export enum DomainEnum {
  SEARCH = 'search',
  BROWSE = 'browse',
  GLOBAL = 'global'
}
